module.exports = __webpack_public_path__ + "img/shefa.bdbbf5ae.png";